import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons'
import { withProps } from '../../../lib/util'

// nah
type V2L1LoadingIndicatorColor = never // FusionColor.BlueMain|FusionColor.White

interface LoadingIconProps {
	big?: boolean
	color?: V2L1LoadingIndicatorColor
}

const LoadingIcon = styled(FontAwesomeIcon, withProps(['icon', 'spin', 'visibility', 'fixedWidth'], []))<LoadingIconProps>(({theme, big}) => ({
	animationDuration: '0.5s',
	fontSize: big ? '3em' : '1em',
}))

interface V2L1LoadingIndicatorArgs extends LoadingIconProps {
	loading?: boolean
	visibility?: 'initial'|'hidden'
}

export const V2L1LoadingIndicator = ({loading = true, visibility = 'initial', big}: V2L1LoadingIndicatorArgs) => {
	if(loading) {
		return (
			<LoadingIcon
				icon={faSpinnerThird}
				spin={true}
				visibility={visibility}
				big={big}
			/>
		)
	}
	return null
}
